export default {
    selectedFiles:[],
    selectedFolder:'',
    bufferedItems:{
        type:'',
        files:[]
    },
    foldersList:[],
    history: {
      currentIndex: 0,
      steps:[]
    },
    filesList:[],
    showImages: 'icons',
    orderFiles:{
      field:'name',
      orderBy: 'asc'
    },
    itemsView: 'list'
}